import React from 'react'
import { IconSVGType } from '../../types/icons'

const ArrowBackIcon = (props: IconSVGType) => {
  return (
    <svg
      width='11'
      height='11'
      viewBox='0 0 11 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.45017 5.04183H3.30824L5.67007 2.47975L5.0701 1.8335L1.69003 5.50016L5.0701 9.16683L5.66584 8.52058L3.30824 5.9585H8.45017V5.04183Z'
        fill='black'
        fillOpacity='0.4'
      />
    </svg>
  )
}

export default ArrowBackIcon
